angular.module('dashboardApp', ['ngRoute', 'ngCookies', 'daterangepicker']);
